let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aYKKX")).then(() => parcelRequire('fTtgN'));